export default __webpack_public_path__ + "static/media/matlab.98ad4951.svg";